import { render, staticRenderFns } from "./GdprBanner.vue?vue&type=template&id=09670edc&scoped=true"
import script from "./GdprBanner.vue?vue&type=script&lang=js"
export * from "./GdprBanner.vue?vue&type=script&lang=js"
import style0 from "./GdprBanner.vue?vue&type=style&index=0&id=09670edc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09670edc",
  null
  
)

export default component.exports